import {MenuItem} from '../../../../vendors/@types/menu';
import {
  faBell,
  faBriefcase,
  faCircleQuestion,
  faEnvelope,
  faFolderOpen,
  faHome,
  faSearch,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

export const menuItems: MenuItem[] = [
  {
    label: 'Página inicial',
    icon: faHome,
    url: '/home',
    id: 'home',
  },
  {
    label: 'Consultar Eventos',
    icon: faSearch,
    url: '/consultar-eventos/inicio',
    id: 'consultar-eventos',
  },
  {
    separator: true,
    id: 'sep-conta',
  },
  {
    label: 'Meu Perfil',
    id: 'meu-perfil',
    url: '/perfil/inicio',
    icon: faUser,
  },
  {
    label: 'Minhas Contribuições',
    icon: faFolderOpen,
    url: '/minhas-contribuicoes/inicio',
    id: 'minhas-contribuicoes',
  },
  {
    label: 'Meus Eventos',
    id: 'meus-eventos',
    url: '/meus-eventos/inicio',
    icon: faBriefcase,
  },
  {
    separator: true,
    id: 'sep-comunicados',
  },
  {
    label: 'Comunicados e Alertas',
    icon: faBell,
    url: '/informes',
    id: 'informes',
    badgeSource: 'informes',
  },
  {
    label: 'Dúvidas frequentes',
    icon: faCircleQuestion,
    url: '/duvidas-frequentes',
    id: 'duvidas-frequentes',
  },
  {
    label: 'Fale conosco',
    icon: faEnvelope,
    url: '/fale-conosco/inicio',
    id: 'fale-conosco',
  },
];
